import { createReducer, on } from '@ngrx/store';
import { loadedAlert } from './admin.actions';
import { initialState } from './admin.state';

export const adminReducer = createReducer(
  initialState,
  on(loadedAlert, (state, { alert }) => ({ ...state, alert })),
);
